import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { DecisionTreeData } from "../models/decisionTree.interface";

/** Mirrors C45SaveModelApiResponse from the backend (DefaultContractResolver → PascalCase) */
export interface C45SaveModelResponse {
  SavedModelId: string;
}

@Injectable({ providedIn: 'root' })
export class DecisionTreeService {
 apiUrl = environment.apiUrl;
    constructor(
    private http: HttpClient
  ) {}

  getDecisionTreeData(): Observable<DecisionTreeData> {
        return this.http.get<DecisionTreeData>(`${this.apiUrl}/api/v1/c45/model`);
      }

  saveDecisionTree(model: DecisionTreeData, id?: string): Observable<C45SaveModelResponse> {
    const url = id
      ? `${this.apiUrl}/api/v1/c45/save?id=${encodeURIComponent(id)}`
      : `${this.apiUrl}/api/v1/c45/save`;
    return this.http.post<C45SaveModelResponse>(url, model);
  }

}